var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"KnowledgeServiceNav",class:_vm.clickIndex !== -1 ? 'isIndex' : ''},[_c('div',{staticClass:"nav_box"})])}
var staticRenderFns = []

export { render, staticRenderFns }